export default "__VITE_ASSET__DuU0lsBZ__"